import Api from ".";
import {
  PX_OBJ_CLASS,
  DASHBOARD_PX_OBJ_CLASS,
  DASHBOARD_MODULE_PX_OBJ_CLASS,
} from "../components/Dashboard/CreateViewDialog/dashboardPayloadConstants";

import { DEVURL } from "./envUrl";
// Get dashboard module details by user, module, and mode
export const getDashboardModuleDetails = async (userId, moduleId, mode = "Min", headers = {}) => {
  const api = new Api();
  const axiosInstance = await api.init({ headers });
  let apiURL = `${DEVURL}/getDashboardModuleDetails/${userId}/${moduleId || "NA"}/${mode}`;
  try {
    const response = await axiosInstance({
      url: apiURL,
      method: "GET",
    });
    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    console.error("Error fetching dashboard module details:", error);
    throw error;
  }
};

// Create or update dashboard module view (project/task/other)
export const createOrUpdateDashboardModuleView = async (payload, headers = {}) => {
  const api = new Api();
  const axiosInstance = await api.init({ headers });
  const apiURL = `${DEVURL}/processDashboard`;
  try {
    const response = await axiosInstance({
      url: apiURL,
      method: "PUT",
      data: payload,
    });
    return response?.data ?? null;
  } catch (error) {
    console.error("Error creating/updating dashboard module view:", error);
    throw error;
  }
};

export const deleteDashboardView = async (moduleId, headers = {}) => {
  const api = new Api();
  const axiosInstance = await api.init({ headers });
  let apiURL = `${DEVURL}/deleteDashboard/${moduleId}`;

  const response = await axiosInstance({
    url: apiURL,
    method: "DELETE",
  });

  return response?.data;
};

// Fetch user attributes (e.g., PM options) by userId
export const fetchUserAttributes = async (userId, headers = {}) => {
  const api = new Api();
  const axiosInstance = await api.init({ headers });
  const apiURL = `${DEVURL}/getFetchUserAttributes/${userId}`;
  try {
    const response = await axiosInstance({
      url: apiURL,
      method: "GET",
    });
    return response?.data ?? null;
  } catch (error) {
    console.error("Error fetching user attributes:", error);
    throw error;
  }
};

// Apply dashboard template
export const applyDashboardTemplate = async (userId, templateName, headers = {}) => {
  const api = new Api();
  const axiosInstance = await api.init({ headers });
  const apiURL = `${DEVURL}/dashboardTemplate`;
  const payload = {
    Dashboard: {
      DashboardModuleList: [
        {
          pxObjClass: DASHBOARD_MODULE_PX_OBJ_CLASS,
          TemplateName: templateName,
          User_ID: userId,
        },
      ],
      pxObjClass: DASHBOARD_PX_OBJ_CLASS,
    },
    pxObjClass: PX_OBJ_CLASS,
  };
  try {
    const response = await axiosInstance({
      url: apiURL,
      method: "PUT",
      data: payload,
    });
    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    console.error("Error applying dashboard template:", error);
    throw error;
  }
};
